module.exports = __webpack_public_path__ + "img/BUTAGAZ_120X35.png.5d65f0c6.png";